import * as AuthActions from 'core/services/store/auth/actions';
import { $ } from '@starberry/components';
import AuthServices from 'core/services/store/auth/services';

export const ResetFormAuth = {
  component: 'form',
  provide: ['auth'],
  props: {
    key: 'reset-form',
    flex: 1,
    onSubmit: (_, context) => (e) => {
      const [state, dispatch] = context?.state?.auth || [];
      e.preventDefault();
      AuthServices(dispatch, AuthActions).resetPassword({
        code: window?.location?.query?.code,
        password: state.form.password,
      });
    },
  },
};

const ResetPassForm = {
  $: ResetFormAuth,
  submitButton: {
    $: 'PrimaryButton',
    type: 'submit',
    children: $('constants.translations.resetPass.RESET_SUBMIT_BTN', 'Change Password'),
  },
  children: [
    {
      $: 'Flex',
      provide: ['auth'],
      children: (_, context) => {
        const [state] = context?.state?.auth || [];
        return {
          $: 'Alert',
          props: {
            status: 'success',
            display: state?.success ? 'flex' : 'none',
            mb: state?.error ? 6 : 0,
            borderRadius: $('constants.input.borderRadius'),
          },
          children: [
            { $: 'AlertIcon' },
            {
              $: 'AlertTitle',
              props: { mr: 2 },
              children: $(
                'constants.translations.resetPass.ALERT_SUCCESS',
                'Please check your Inbox to reset your password'
              ),
            },
          ],
        };
      },
    },
    {
      $: 'Stack',
      props: {
        spacing: 6,
      },
      $children: [
        {
          $: 'FormControl',
          props: {
            id: 'password',
            key: 'password',
          },
          children: [
            {
              $: 'InputField',
              provide: ['auth'],
              props: {
                type: 'password',
                label: 'New Password',
                required: true,
                inputProps: {
                  name: 'password',
                  autoComplete: 'password',
                },
                onChange: (_, context) => {
                  return (e) => {
                    const [, dispatch] = context?.state?.auth ?? [];
                    dispatch(AuthActions.setFormField('password', e.target.value));
                  };
                },
                value: (_, context) => {
                  const [state] = context?.state?.auth || [];
                  return state?.form?.password;
                },
              },
            },
          ],
        },
        $('submitButton'),
      ],
    },
  ],
};

export default ResetPassForm;
